import React, { forwardRef, useId } from 'react';
import './FormField.css';

export interface FormFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'id'> {
  label: string;
  hint?: string;
  error?: string;
  children?: React.ReactNode;
}

export const FormField = forwardRef<HTMLInputElement, FormFieldProps>(
  ({ label, hint, error, required, className, children, ...rest }, ref) => {
    const id = useId();
    return (
      <div data-testid="form-field" className={`form-field${error ? ' form-field--error' : ''}${className ? ` ${className}` : ''}`}>
        <label className="form-field__label" htmlFor={id}>
          {label}
          {required && <span data-testid="required-mark" className="form-field__required" aria-hidden="true"> *</span>}
        </label>
        {children ?? (
          <input
            ref={ref}
            id={id}
            className="form-field__input"
            required={required}
            aria-invalid={error ? 'true' : undefined}
            aria-describedby={error ? `${id}-err` : hint ? `${id}-hint` : undefined}
            {...rest}
          />
        )}
        {hint && !error && <span id={`${id}-hint`} className="form-field__hint">{hint}</span>}
        {error && <span id={`${id}-err`} className="form-field__error" role="alert">{error}</span>}
      </div>
    );
  },
);
FormField.displayName = 'FormField';
